import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { AdminFormRow } from "./types";

// GET /api/admin/forms — list of all forms (draft + published + archived).
//
// Phase 7 sub-bucket 11. Reads the full FormRow shape from the worker;
// list-page filter/sort runs in-memory against the cached rows (matches
// sub-bucket 10's partners list convention). The same key is invalidated
// by every form mutation hook (Phase 6 session 4).
export function useForms(opts: { enabled?: boolean } = {}) {
  return useQuery<AdminFormRow[], ApiClientError>({
    queryKey: queryKeys.adminForms.list(),
    queryFn: () => apiFetch<AdminFormRow[]>("/admin/forms"),
    enabled: opts.enabled ?? true,
  });
}
